import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IJobFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		number?: any;
}

export class JobFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public number: IEntityModelField = { name: "number", displayName: "Number", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.number);
	}
}

export class JobDTO implements IEntityModel {
	protected jobName: string = "JobModel";
	protected jobKeyField: string = "id";
	protected jobDisplayName: string = "Job|Jobs";
	protected jobFields = new JobFields();
	public get name(): string { return this.jobName };
	public get keyField(): string { return this.jobKeyField };
	public get displayName(): string { return this.jobDisplayName };
	public get fields(): JobFields { return this.jobFields };

	constructor() {};
}
